import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-about-protecttai',
  templateUrl: './about-protecttai.component.html',
  styleUrls: ['./about-protecttai.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AboutProtecttaiComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  slides = [
    {
      index: 1,
      img: "assets/images/new/shivkumar.webp",
      name: this.sanitizer.bypassSecurityTrustHtml("<span class='textred'>Shivkumar Pandey</span>"),
      des: this.sanitizer.bypassSecurityTrustHtml("<span class='textblue'>Group CISO <br> Bombay Stock Exchange</span>"),
      message: this.sanitizer.bypassSecurityTrustHtml("''<span class='textred'>App</span><span class='textblue'>Protectt</span> Mobile App RASP security helped us to enhance our Mobile App Security with quick implementation and also provided visibility into threats and prevention on real-time. Now, our team can focus more on App Features development while <span class='textred'>App</span><span class='textblue'>Protectt</span> is adding a layer of security for our mobile apps.''"),

      link: "/appprotectt",
      button1: "Request a Demo",
      button2: "Learn More"
    },
    {
      index: 2,
      img: "assets/images/new/nilesh_sangoi.webp",
      name: this.sanitizer.bypassSecurityTrustHtml("<span class='textred'>Nilesh Sangoi</span>"),
      des: this.sanitizer.bypassSecurityTrustHtml("<span class='textblue'>Chief Information Officer <br> Fincare Small Finance</span>"),
      message: this.sanitizer.bypassSecurityTrustHtml("''<span class='textred'>App</span><span class='textblue'>Protectt</span> helped us achieve high standards of Mobile Banking App security and fraud control for our customers. It also helped in complying with RBI’s digital payment security master direction specific to Mobile Banking and a quick Go-to-Market.''"),

      link: "",
      button1: "Request a Demo",
      button2: ""
    }
  ];

  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1, "autoplay": true, "autoplaySpeed": 4000, "dots": true, prevArrow: null, nextArrow: null };

  slickInit() {
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  testimonialInit() {
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  breakpoint() {
  }

  afterChange() {
    this.slickInit()
    this.testimonialInit()
    $(".slide.slick-slide .custom-box-content").hide();
    $(".slide.slick-slide.slick-active .custom-box-content").show();
    //$(".bnrcontent").css("visibility", "visible");
    $(".bnrcontent").css("transform", "translateZ(0)");
    $(".bnrcontent").css("transition-duration", "3s");

  }


  beforeChange() {
    //$(".bnrcontent").css("visibility", "hidden");
    $(".bnrcontent").css("transform", "translate3d(100px,0,0)");
    $(".bnrcontent").css("transition-duration", "3s");
  }

}
